// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__vnU9T","footer":"ModalUpdate_footer__121t1"};